/**
 * FAQ-Abschnitt: aufklappbare Frage-Antwort-Paare (Req 8).
 *
 * Noch nicht umgesetzte Funktionen (z. B. automatische Routenplanung) werden
 * konzeptionell formuliert und nicht als vorhanden dargestellt (Req 8.3, 13).
 */

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { useI18n } from "../../i18n/I18nProvider";
import { welcomeColors } from "./welcomeTheme";
import { SectionLabel } from "./welcomeShared";

/** Ein FAQ-Eintrag — Texte über i18n-Keys (Req 8.1). */
interface FaqItem {
  questionKey: string;
  answerKey: string;
}

const FAQ_ITEMS: FaqItem[] = [
  { questionKey: "welcome.faq.q1.q", answerKey: "welcome.faq.q1.a" },
  { questionKey: "welcome.faq.q2.q", answerKey: "welcome.faq.q2.a" },
  { questionKey: "welcome.faq.q3.q", answerKey: "welcome.faq.q3.a" },
  { questionKey: "welcome.faq.q4.q", answerKey: "welcome.faq.q4.a" },
];

export default function WelcomeFaq() {
  const { t } = useI18n();
  const theme = useTheme();
  const colors = welcomeColors(theme.palette.mode);

  return (
    <Container maxWidth="lg">
      <Box
        id="fragen"
        sx={{ pb: 10, maxWidth: 820, mx: "auto", scrollMarginTop: 88 }}
      >
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <SectionLabel>{t("welcome.faq.sectionLabel")}</SectionLabel>
          <Typography variant="h2" component="h2" sx={{ fontSize: { xs: 30, md: 38 } }}>
            {t("welcome.faq.sectionTitle")}
          </Typography>
        </Box>
        {FAQ_ITEMS.map((item) => (
          <Accordion
            key={item.questionKey}
            elevation={0}
            sx={{
              border: `1px solid ${colors.border}`,
              mb: 1.2,
              borderRadius: "14px !important",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreRoundedIcon />}
              sx={{ minHeight: 44 }}
            >
              <Typography component="h3" fontWeight={700}>
                {t(item.questionKey)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography color="text.secondary" sx={{ lineHeight: 1.75 }}>
                {t(item.answerKey)}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
  );
}
